<template>
    <div>
        <div v-if="!isAdmin" class="feedback-index" :class="{'feedback-index-filter': componentIndex === 1}">
            <div class="navlist-box">
                
                <keep-alive>
                    <tab :tabFontSize="'16px'" :tabList="feedbackTab" ref="tab" :name="'dataTab'" @onSwitch="tabSwitch"></tab>
                </keep-alive>
                <div v-if="componentIndex === 1" class="business-type">
                    <div @click="changeFilterReadItem(index)" class="type-item" :class="{'type-item-active': item.check}" v-for="(item, index) in filterReadList" :key="item.name">
                        {{item.name}}
                    </div>
                </div>
            </div>
            <keep-alive>
                <component v-bind:is="currentTabComponent" :componentIndex="componentIndex"  :isAdmin="isAdmin" :filterReadList="filterReadList"></component>
            </keep-alive>
        </div>
        <div v-if="isAdmin" class="feedbackList">
            <MyFeedback :isAdmin="isAdmin"/>
        </div>
    </div>
</template>

<script>
    import tab from 'comps/tab';
    import popup from './components/popup.vue';
    import Feedback from './feedback.vue'
    import MyFeedback from './myFeedback.vue'
    import api from '../../service/modules/feedback'
    import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
    
    export default {
        name: 'Feedback',
        components: {
            tab,
            popup,
            Feedback,
            MyFeedback
        },
        data() {
            return {
                componentIndex: 0,
                componentsAttr: [
                    Feedback,
                    MyFeedback
                ],
                feedbackTab: ['意见反馈', '我的反馈'],
                filterReadList: [
                    {name: '全部', check: true, isReply: 2},
                    {name: '未回复', check: false, isReply: 0},
                    {name: '已回复', check: false, isReply: 1},
                ],
                isAdmin: false
            }
        },
        beforeRouteEnter:(to,from,next)=>{
            console.log('to',to)
            console.log('from',from)
            console.log('next',next)
            
            next(vm=>{
                console.log("from.path.indexOf('/feedback/feedbackDetail')",from.path.indexOf('/feedback/feedbackDetail'))
                if (from.path.indexOf('/feedback/feedbackDetail') !== -1) {
                    vm.$refs.tab.switchTab(1)
                }
            })
        },
        computed: {
            currentTabComponent() {
                return this.componentsAttr[this.componentIndex]
            },
            ...mapState({
                // componentIndexState: state => state.componentIndex
            }),
            
            ...mapMutations({
                // setComponentIndex: 'setComponentIndex'
            })
        },
        watch: {

        },
        methods: {
            tabSwitch(index) {
                
                this.componentIndex = index
                console.log('this.TabList',this.componentIndex)
                // this.$store.commit('feedback/setComponentIndex', index);
                // if (this.$store.state.feedback.componentIndex == 0) {
                //     this.componentIndex = this.$store.state.feedback.componentIndex
                // }
                
                // console.log('this.$store.componentIndex',this.$store.state.feedback.componentIndex)
                
            },
            changeFilterReadItem(index) {
                this.filterReadList.forEach(item => {
                    item.check = false
                })
                this.filterReadList[index].check = true
            },
            idAdmin() {
                api.currentUser().then(res => {
                    this.isAdmin = res.data.userInfo.manager
                    console.log(this.isAdmin)
                    // if (this.isAdmin) {
                    //     this.$router.push({
                    //         path: '/myFeedback'
                    //     })
                    // }
                })
            }
        },
        created() {
            this.idAdmin()
            console.log('this.$store.componentIndex',this.$store.state.feedback.componentIndex)
        },
        mounted() {

        }
    }
</script>

<style lang="less" scoped>
.feedbackList {
    background-color: #F5F6F9;
}
/deep/ .data-card-tab-item {
    font-size: 16px !important;
    font-weight: 700 !important
}
.feedback-index-filter .navlist-box {
    z-index: 9999;
}
    .feedback-index{
        width: 100%;
        background: rgba(251, 251, 251, 1);
        box-sizing: border-box;
        padding-bottom: 90px;
        font-family: PingFangSC-Regular;
        padding-top: 56px;

        .navlist-box {
            z-index: 999;
            width: 100%;
            height: 56px;
            box-sizing: border-box;
            padding-top: 6px;
            background-color: #fff;
            padding-left: 12px;
            position: fixed;
            left: 0;
            top: 0;
        }

        .business-type{
                display: flex;
                flex-wrap: wrap;
                margin-top: 17px;
                .type-item{
                    margin-left: 8px;
                    width: 64px;
                    padding: 8px 0;
                    box-sizing: border-box;
                    border-radius: 2px;
                    text-align: center;
                    color: #171A1D;
                    border: solid rgba(162, 163, 164,0.5) 0.5px;
                    background: #fff;
                    font-size: 12px;
                    &:nth-child(1){
                        margin-left: 0;
                    }
                }
                .type-item-active{
                    color: #36B374;
                    border: solid #36B374 0.5px;
                    background: rgba(54,179,116,0.05);
                }
            }
    }
    .feedback-index-filter{
        height: 100%;
        padding-top: 101px;
        padding-bottom: 24px;
        .navlist-box {
            height: 101px;
            padding-bottom: 10px;
        }
    }
</style>